/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import {
  FormDateField,
  FormDialog,
  FormFileUploadField,
  FormPhoneField,
  FormSwitchField,
  FormSelectField,
  FormTextField,
} from '../src';
import Form from "./FormTest";
import ToggleButton from "./ToggleButton";
import { Divider } from '@material-ui/core';
import { Playground } from 'docz';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <p>{`MUI Form Fields was developed by `}<a parentName="p" {...{
        "href": "https://zerosoft.com.br/en/"
      }}>{`ZeroSoft`}</a>{` to help
us build lots of forms to our clients with ease. We based ourselves on
`}<a parentName="p" {...{
        "href": "https://material-ui.com/"
      }}>{`Material UI`}</a>{` and made the most so we can build a
form with the minimum amount of code possible.`}</p>
    <p>{`You can make questions, propose improvements and changes on our repository
`}<a parentName="p" {...{
        "href": "https://github.com/0soft/mui-form-fields"
      }}>{`here`}</a></p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`Install all of MUI Form Fields Peer Dependencies`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm i --save @date-io/core@^1.3.6 @date-io/moment@^1.3.6 @material-ui/core@^4.1.0 @material-ui/icons@^4.1.0 classnames@^2.2.6 core-js@^3.1.3 css-vendor@^2.0.2 final-form@^4.13.1 is-plain-object@^3.0.0 jss moment@^2.24.0 react@>=16.8.6 react-dom@>=16.8.6 react-dropzone@^10.1.5 react-final-form@^6.0.1 react-select@^3.0.4 react-number-format@^4.0.8
`}</code></pre>
    <p>{`Then install MUI Form Fields`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm i --save mui-form-fields
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`This Form Components are primarily based on Final Form, you can take a look
into their `}<a parentName="p" {...{
        "href": "https://github.com/final-form/final-form"
      }}>{`documentation`}</a>{` for more
advanced instructions.`}</p>

    <p>{`You'll always need a `}<inlineCode parentName="p">{`<Form>`}</inlineCode>{` component wrapping our Form Fields, so as long as
you have a code like this:`}</p>
    <Playground __position={0} __code={'<Form\n  render={() => {\n    return <FormTextField icon=\"person\" name=\"name\" label=\"Name\" />\n  }}\n/>'} __scope={{
      props: this ? this.props : props,
      FormDateField,
      FormDialog,
      FormFileUploadField,
      FormPhoneField,
      FormSwitchField,
      FormSelectField,
      FormTextField,
      Form,
      ToggleButton,
      Divider,
      Playground
    }} mdxType="Playground">
  <Form render={() => {
        return <FormTextField icon="person" name="name" label="Name" mdxType="FormTextField" />;
      }} mdxType="Form" />
    </Playground>
    <p>{`This way you may just start importing our components and play around with a
combination of them:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import {
  FormDateField,
  FormDialog,
  FormFileUploadField,
  FormPhoneField,
  FormSwitchField,
  FormTextField,
} from 'mui-form-fields';

// Do your magic here...
`}</code></pre>
    <Playground __position={1} __code={'<Form\n  render={() => {\n    return (\n      <>\n        <FormTextField\n          icon=\"person\"\n          name=\"name\"\n          label=\"Name (min: 3 characters)\"\n          validate=\"required | min:3\"\n        />\n        <Divider />\n        <FormTextField\n          icon=\"mail\"\n          name=\"email\"\n          label=\"Email\"\n          validate=\"required | email\"\n        />\n        <FormSwitchField icon=\"security\" name=\"protected\" label=\"Protected\" />\n      </>\n    )\n  }}\n/>'} __scope={{
      props: this ? this.props : props,
      FormDateField,
      FormDialog,
      FormFileUploadField,
      FormPhoneField,
      FormSwitchField,
      FormSelectField,
      FormTextField,
      Form,
      ToggleButton,
      Divider,
      Playground
    }} mdxType="Playground">
  <Form render={() => {
        return <>
          <FormTextField icon="person" name="name" label="Name (min: 3 characters)" validate="required | min:3" mdxType="FormTextField" />
          <Divider mdxType="Divider" />
          <FormTextField icon="mail" name="email" label="Email" validate="required | email" mdxType="FormTextField" />
          <FormSwitchField icon="security" name="protected" label="Protected" mdxType="FormSwitchField" />
        </>;
      }} mdxType="Form" />
    </Playground>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p>{`Even complex dialogs can be mounted as easily as:`}</p>
    <Playground __position={2} __code={'<ToggleButton\n  text=\"Open Dialog\"\n  variant=\"contained\"\n  color=\"primary\"\n  render={(open, setOpen) => {\n    // The really important code:\n    return (\n      <FormDialog\n        size=\"sm\"\n        title=\"Create User\"\n        onClose={() => setOpen(false)}\n        onSubmit={async (...args) => {\n          return new Promise(resolve => {\n            setTimeout(() => {\n              resolve()\n              setOpen(false)\n            }, 2000)\n          })\n        }}\n        open={open}\n        dividers\n      >\n        <FormTextField icon=\"person\" name=\"name\" label=\"Full Name\" />\n        <FormTextField icon=\"mail\" name=\"email\" label=\"Email\" />\n        <FormPhoneField name=\"phone\" label=\"Phone\" />\n        <FormDateField icon=\"today\" name=\"birthday\" label=\"Birthday\" />\n        <FormSwitchField icon=\"security\" name=\"protected\" label=\"Protected\" />\n        <FormSwitchField icon=\"verified_user\" name=\"admin\" label=\"Admin\" />\n        <FormFileUploadField\n          icon=\"attachment\"\n          name=\"identification\"\n          label=\"Social Security\"\n        />\n      </FormDialog>\n    )\n  }}\n/>'} __scope={{
      props: this ? this.props : props,
      FormDateField,
      FormDialog,
      FormFileUploadField,
      FormPhoneField,
      FormSwitchField,
      FormSelectField,
      FormTextField,
      Form,
      ToggleButton,
      Divider,
      Playground
    }} mdxType="Playground">
  <ToggleButton text="Open Dialog" variant="contained" color="primary" render={(open, setOpen) => {
        // The really important code:
        return <FormDialog size="sm" title="Create User" onClose={() => setOpen(false)} onSubmit={async (...args) => {
          return new Promise(resolve => {
            setTimeout(() => {
              resolve();
              setOpen(false);
            }, 2000);
          });
        }} open={open} dividers mdxType="FormDialog">
          <FormTextField icon="person" name="name" label="Full Name" mdxType="FormTextField" />
          <FormTextField icon="mail" name="email" label="Email" mdxType="FormTextField" />
          <FormPhoneField name="phone" label="Phone" mdxType="FormPhoneField" />
          <FormDateField icon="today" name="birthday" label="Birthday" mdxType="FormDateField" />
          <FormSwitchField icon="security" name="protected" label="Protected" mdxType="FormSwitchField" />
          <FormSwitchField icon="verified_user" name="admin" label="Admin" mdxType="FormSwitchField" />
          <FormFileUploadField icon="attachment" name="identification" label="Social Security" mdxType="FormFileUploadField" />
        </FormDialog>;
      }} mdxType="ToggleButton" />
    </Playground>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  